import { render, staticRenderFns } from "./clusters_deprecation_alert.vue.js?vue&type=template&id=5bc33a48&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./clusters_deprecation_alert.vue?vue&type=template&id=5bc33a48&vue3"
import script from "./clusters_deprecation_alert.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./clusters_deprecation_alert.vue?vue&type=script&lang=js&vue3"
export * from "./clusters_deprecation_alert.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./clusters_deprecation_alert.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports